<template>
    <v-app>
        <nav-drawer v-if="showMenus"></nav-drawer>
        <v-app-bar app absolute clipped-left extended extension-height="7" v-if="showMenus">
            <v-app-bar-nav-icon @click.native="toggleDisplayNav"></v-app-bar-nav-icon>
            <img :src="iconURL" height="50" @click="goHome" class="home-logo" :title="currentAppVersionText" />
            <v-toolbar-title>
                <span class="home-link" v-if="$vuetify.breakpoint.smAndUp" @click="goHome">{{ appTitle }}</span>
                <v-icon>chevron_right</v-icon>
                {{ subtitle }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <FollowupAlertIcon class="mr-4 mt-3">
            </FollowupAlertIcon>
            <profile></profile>
            <v-progress-linear slot="extension" :indeterminate="true" v-if="loadingRoute"></v-progress-linear>
        </v-app-bar>
        <v-main class="grey lighten-2">
            <router-view :key="$route.fullPath"></router-view>
        </v-main>
    </v-app>
</template>

<style>
    .v-card:not(.v-select-list):not(.v-picker):not(.no-padding) {
        /* soften the edges of most of the site content by adding a bit of spacing */
        margin-bottom: 10px; /* note: this adds an awful line to the bottom of dialogs, which we can stop happening by specifying further :not conditions */
        padding: 10px;
    }

    /* the margin-bottom of 10px in the above rule should not apply when the card is inside a dialog popup */
    /* this prevents the "awful line" mentioned above, without the need to add the "no-padding" class to every popup dialog */
    #app .v-dialog .v-card {
        margin-bottom: 0px;
    }

    .dialog-action-buttons .flex {
        /* in dialog popups, just prevent buttons that are side by side from touching each other */
        padding-right: 5px;
        padding-left: 5px;
    }

    .v-dialog .v-toolbar {
        /* just a bit of extra space below the toolbar used in dialog popups  */
        margin-bottom: 10px;
    }

    .v-dialog .v-card form {
        /* dialogs that take up the full screen need just a little bit of padding on the sides on the page so that the content doesn't sit flush on the edge of a phone/tablet */
        padding: 7px;
    }
    .v-list-item--disabled.primary--text {
        color: var(--v-navigation-darken3) !important;
        font-style: italic;
    }

    @media only screen and (min-width: 960px) {
        #app .container {
            max-width: 100%;
        }
    }

    .home-logo, .home-link {
        cursor: pointer;
    }

    .confirm-dialog .flex {
        padding-left: 5px;
        padding-right: 5px;
    }

    /* some general print styles */
    @media print {
        .notPrinted, .v-toolbar, .v-navigation-drawer, .v-btn, div.v-datatable, .do-not-print {
            display: none;
        }

        main.v-content {
            display: block;
            -webkit-box-flex: unset;
            flex: unset;
        }

        /* unfortunately the important is needed, because the default padding is inline */
        main {
            padding-top: 0px !important;
        }

        .v-content {
            padding: 0px !important;
        }

        .container {
            padding: 0px;
            margin: 0px;
            max-width: none;
        }

        .v-card {
            padding: 0px !important;
            margin-bottom: 0px !important;
            border: none;
            box-shadow: none;
            -webkit-box-shadow: none;
        }

        .v-datatable tr {
            page-break-inside: avoid;
        }
    }
</style>

<script>

import NavDrawer from "./components/navigation/NavDrawer.vue";
import Profile from "./components/authentication/Profile.vue";
import BTGIcon from "./assets/img/btg_logo.svg"
import FollowupAlertIcon from "./components/medicalRecords/FollowupAlert.vue";

export default {
    components: {
        NavDrawer,
        Profile,
        FollowupAlertIcon
    },
    data() {
        return {
            
        };
    },
    computed: {
        currentAppVersionText: function() {
            return "Current version: " +  process.env.VUE_APP_VERSION;
        },
        loadingRoute: function() {
            return this.$store.state.generalStore.loadingRoute;
        },
        subtitle: function() {
            return this.$route.meta.title;
        },
        appTitle() {
            return process.env.VUE_APP_TITLE;
        },
        showMenus() {
            return !this.$route.meta.hideMenus;
        },
        iconURL() {
            return BTGIcon;
        }
    },
    methods: {
        toggleDisplayNav() {
            this.$store.commit("generalStore/toggleDisplayNavDrawer");
        },
        goHome() {
            this.$router.push({ name: "home" });

            this.$store.commit("generalStore/hideNavDrawer");
        }
    }
}

</script>
